<template>
  <v-container
    style="max-width: 8in; background-color: transparent"
    class="ml-0"
    id="to_hit_cards_id"
    ref="easyPrint"
  >
    <!--//@*/*
    //    *BUS Dice Cars  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
    <div v-if="pages.length > 0" style="max-width: 8in; height: 88in">
      <div class="page ml-0" v-for="(pg, index1) in pages" :key="index1">
        {{ index1 }}
        <v-container>
          <v-row
            align-items:
            start
            style="width: 100%; height: 2.1in"
            class="justify-space-around"
            v-for="(row, index2) in rows"
            :key="index2"
          >
            <v-col
              class="dc_container"
              v-for="(col, index3) in cols"
              :key="index3"
            >
              <!-- 'page: ' {{ index1 }} 'row: ' {{ index2 }} 'col: '
              {{ index3 }} 'total: '
              {{ index1 * 8 + index2 * 2 + index3 * 1 }} -->
              <div class="dicecard mt2 ml-1">
                <div class="rowflex ml-2">
                  Beta FX&copy; Half Location
                  <span style="text-align: right" class="pr-2"
                    >#{{
                      all_loc_data[index1 * 8 + index2 * 2 + index3 * 1].loc
                    }}</span
                  >
                </div>
                <div class="rowflex ml-2 hurtbits">
                  PAIN:{{
                    all_loc_data[index1 * 8 + index2 * 2 + index3 * 1].pain
                  }}| BLD:{{
                    all_loc_data[index1 * 8 + index2 * 2 + index3 * 1].bleed
                  }}| PEN:{{
                    all_loc_data[index1 * 8 + index2 * 2 + index3 * 1].penalty
                  }}| MV:{{
                    all_loc_data[index1 * 8 + index2 * 2 + index3 * 1].move
                  }}
                </div>

                <div class="locdescr ml-2">
                  {{
                    all_loc_data[index1 * 8 + index2 * 2 + index3 * 1]
                      .specialText
                  }}
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
.red {
  color: red;
}
.page {
  width: 8in;
  height: 10in;
  border: 5px solid rgb(92, 145, 206);
  background-color: white !important;
}
.rowflex {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: baseline;
}
.hurtbits {
  font-size: 0.8rem;
}
.locdescr {
  font-size: 11px;
}
.dc_container {
  width: 3in;
  height: 2in;
}
.dicecard {
  width: 3in;
  height: 2in;
  border: 3px solid rgb(0, 0, 0);
  background-color: whitesmoke;
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "half_loc_cards",
  mixins: [bus_common],
  props: [""],
  data() {
    return {
      all_loc_data: [],
      rr: "red--text",
      cols: [],
      rows: [],
    };
  },
  computed: {
    pages() {
      //   this.mrbreakpoint("page");
      var page_cnt = [];
      for (let i = 0; i < this.all_loc_data.length; i += 8) {
        page_cnt.push(i);
      }
      //    this.mrbreakpoint(result);
      return page_cnt;
    },
  },
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    total_index() {
      return 5;
    },
    get_half_loc_data() {
      this.show_loader(true);
      var formIn = {};

      formIn.apiname = "get_half_loc_data";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.all_loc_data = self.mno(data);
          this.show_loader(false);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    fillArrayInt(array, length) {
      for (let index = 0; index < length; index++) {
        array.push(index);
      }
      return array;
    },
    init() {
      this.show_loader(false);
      this.get_half_loc_data();
      this.rows = this.mno(this.fillArrayInt(this.rows, 4));
      this.cols = this.mno(this.fillArrayInt(this.cols, 2));
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
